import styled from 'styled-components';
import { Button } from '@gr-monorepo/common/ui';

export const Container = styled.div<{ color: string }>`
  display: flex;
  gap: 24px;
  flex-direction: column;
  padding: 16px 24px 24px;
  border-radius: 20px;
  background: ${(props) => props.color};
`;

export const ButtonStyle = styled(Button)`
  width: 260px;
  height: 38px;
  font-size: 12px;
`;

export const Title = styled.div`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.2px;
`;

export const Wrap = styled.div`
    display: grid;
    gap: 24px; 
    grid-template-columns: 1fr;
    grid-auto-flow: row;
}
  & > * {
    flex-basis: 50%;
    flex-shrink: 1;
  }
`;

export const WrapPlate = styled.div`
  padding: 24px 24px 32px;
  border-radius: 20px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  &:hover {
    box-shadow: 0px 12px 24px 0px rgba(57, 78, 127, 0.2);
  }
`;

export const InnerPlate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const WrapBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Stage = styled.div<{ width?: string; height?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  line-height: 34px;
  font-weight: 400;
  color: #fff;
  border-radius: 50%;
  width: ${(props) => props.width || '40px'};
  height: ${(props) => props.height || '40px'};
`;

export const Line = styled.div<{ color: string }>`
  width: 96px;
  height: 2px;
  background: ${(props) => props.color};
`;

export const TitlePlate = styled.div`
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
`;

export const TextPlate = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;


export const TextModalWrap = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
`;


export const ModalBlock = styled.div`
  display: grid;
  gap: 32px;
  justify-items: center;
`;

export const FieldFlexRow = styled.div`
  display: flex;
  align-items: center;
`;

export const PolicyLink = styled.a`
  font-weight: 700;
  line-height: 22px;
  color: #7f39fb;
  outline: none;
  &:active,
  &:focus,
  &:hover,
  &:visited {
    color: #7f39fb;
  }
`;

export const SuccessWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  height: 190px;
  > * {
    flex: 0 0 auto;
  }
`;

export const SuccessText = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
`;
